import { useRef } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import QRCode from "react-qr-code";
import { IoCloseSharp } from "react-icons/io5";
import { RiLinkM } from "react-icons/ri";
import { RiFileCopyLine } from "react-icons/ri";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const EventqrModal = ({ event, Openqr, setOpenqr }) => {
  const { t } = useTranslation('view_event');
  const qrRef = useRef(null);
  const handleClose = () => {
    setOpenqr(false);
  };

  const copy = () => {
    navigator.clipboard.writeText(
      document.querySelector('input[name="name"]').value
    );
    toast.success(t('copied'));
  };

  // Function to handle the download of QR code with white background and padding
  const downloadQRCode = () => {
    const padding = 20;
    const canvas = document.createElement("canvas");
    const svg = qrRef.current.querySelector("svg");
    const svgData = new XMLSerializer().serializeToString(svg);

    const img = new Image();
    const svgBlob = new Blob([svgData], { type: "image/svg+xml" });
    const url = URL.createObjectURL(svgBlob);

    img.onload = () => {
      const canvasWidth = img.width + 2 * padding;
      const canvasHeight = img.height + 2 * padding;

      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      const ctx = canvas.getContext("2d");

      ctx.fillStyle = "#FFFFFF";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Draw the image (QR Code) with padding, centering it in the canvas
      ctx.drawImage(img, padding, padding);

      const dataUrl = canvas.toDataURL("image/png");
      const a = document.createElement("a");
      a.href = dataUrl;
      a.download = "qr-code.png";
      a.click();
    };

    img.src = url;
  };

  return (
    <Dialog
      open={Openqr}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "20px",
        },
      }}
    >
      <div>
        <DialogTitle>
          <div className="flex justify-between items-center">
            <div></div>
            <div className="font-semibold">{t('event_QR_code')}</div>
            <div onClick={handleClose}>
              <IoCloseSharp cursor={"pointer"} size={25} />
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="flex flex-col gap-4 justify-center">
            <div className="flex justify-center">
              <div
                className="col-span-1 bg-[#f2f3f4] flex justify-center p-2 rounded-lg"
                style={{ textAlign: "center" }}
              >
                {event.url && (
                  <div ref={qrRef}>
                    <QRCode
                      bgColor="transparent"
                      title="GeeksForGeeks"
                      value={event.url}
                      size={200}
                    />
                  </div>
                )}
              </div>
            </div>
            <div>
              <div className="flex flex-col justify-center items-center h-[100%] gap-2 w-full">
                <div className="flex flex-col gap-2 justify-center items-center">
                  <div className="flex justify-center flex-wrap text-center">
                    <div className="" style={{ textAlign: "center" }}>
                      {t('name')} : &nbsp;
                    </div>
                    <div className="font-semibold">{event.name}</div>
                  </div>
                  <div className="flex justify-center flex-wrap text-center">
                    <div className="" style={{ textAlign: "center" }}>
                      {t('date')} : &nbsp;
                    </div>
                    <div className="font-semibold">
                      {new Date(event.date).toLocaleDateString(`${localStorage.getItem('i18nextLng') === 'fr' ? 'fr-FR' : 'en-US'}`, {
                        weekday: "long",
                        month: "long",
                        day: "2-digit",
                        year: "numeric",
                      })}
                    </div>
                  </div>
                </div>
                <div className="w-full">
                  <div className="relative">
                    <input
                      type="text"
                      value={event.url}
                      disabled
                      className="border truncate border-[#c3cbd7] py-[12px] rounded-[10px] px-3 text-[14px] w-full pl-10 pr-24"
                      name="name"
                    />
                    <RiLinkM
                      className="absolute left-3 top-1/2 transform -translate-y-1/2 text-black-800"
                      size={20}
                    />
                    <div
                      onClick={() => copy()}
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#3686FF] cursor-pointer flex gap-1 items-center bg-[#e4f1f7] py-1 px-2 rounded-lg"
                    >
                      <RiFileCopyLine />
                      {t('copy')}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button
            onClick={downloadQRCode}
            className="bg-[#3686FF] text-white rounded-lg mt-5 w-full py-[12px] text-[14px]"
          >
            {t('download_QR')}
          </button>
        </DialogContent>
      </div>
    </Dialog>
  );
};

export default EventqrModal;
